import { getEnvRequired } from '../../shared/utilities/env';
import { ApiClient } from '../shared/api/client';

import { OptionWayUrlJSONAPIResponse } from './types';

const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

const apiClient = new ApiClient(false);

export async function fetchOptionWayUrl() {
    const url = `${REQUEST_MANAGER_API_URL}/transport-partnership/admin-url-flight-partner`;
    const response = await apiClient.get<OptionWayUrlJSONAPIResponse>(url);
    return { url: response.data.attributes.url };
}
